import { Brand } from '@org-avp/models';

export const extractBrand = (marketingCode?: string): Brand | undefined => {
  if (!marketingCode) {
    return undefined;
  }

  const brand = marketingCode.charAt(0);
  if (brand !== 'V' && brand !== 'N') {
    return undefined;
  }

  return brand as Brand;
};
